import type { OnboardingState } from "@atlas/shared";
import { apiGet, apiPost } from "../lib/api-client";

export type { OnboardingState, OnboardingStep, OnboardingStepKey } from "@atlas/shared";

export const ONBOARDING_QUERY_KEY = ["account/onboarding"] as const;

export function fetchOnboarding(): Promise<OnboardingState> {
  return apiGet("/account/onboarding");
}

export function completeOnboarding(): Promise<{ completedAt: string }> {
  return apiPost("/account/onboarding/complete");
}
